import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=24364974"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24364974')) {
      api.createRecord('24364974', component.options)
    } else {
      api.reload('24364974', component.options)
    }
    module.hot.accept("./FormInput.vue?vue&type=template&id=24364974", function () {
      api.rerender('24364974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormInput.vue"
export default component.exports